import {} from '../models';
export const currencyToNumberString = (currency) => (currency ?? '').replace(/[^0-9.-]+/g, '');
export const formatCurrencyAmount = ({ amount = 0, currency, precision = 2, }) => {
    const transformedAmount = typeof amount === 'string' ? parseFloat(amount || '0') : amount;
    const formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: precision,
        maximumFractionDigits: precision,
    });
    return `${formatter.format(transformedAmount)} ${currency}`;
};
